import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Import components from their new locations
import Home from './pages/Home';
import GetProtected from './pages/GetProtected';
import StayCompliant from './pages/StayCompliant';
import HowWeHelp from './pages/HowWeHelp';
import ContactUs from './pages/ContactUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FAQ from './pages/FAQ';
import PackagesForDevelopers from './pages/PackagesForDevelopers';
import OurFounder from './pages/OurFounder';
import PqcInTheNews from './pages/PqcInTheNews';
import WhyChooseUs from './pages/WhyChooseUs';
import Kemforge from './pages/Kemforge';
import QuantumTlsTransformer from './pages/QuantumTlsTransformer';

// Import components
import CookieConsentBanner from './components/CookieConsent';
import Navbar from './components/Navbar';
import { initializeGTM, checkExistingConsent } from './utils/analytics';

function App() {
  useEffect(() => {
    // Initialize GTM with existing consent state on app load
    const setupAnalytics = async () => {
      const consentState = await checkExistingConsent();
      await initializeGTM(consentState);
    };

    setupAnalytics();
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/get-protected" element={<GetProtected />} />
          <Route path="/stay-compliant" element={<StayCompliant />} />
          <Route path="/why-choose-us" element={<WhyChooseUs />} />
          <Route path="/pqc-in-the-news" element={<PqcInTheNews />} />
          <Route path="/how-we-help" element={<HowWeHelp />} />
          <Route path="/our-founder" element={<OurFounder />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/kemforge" element={<Kemforge />} />
          <Route path="/quantum-tls-transformer" element={<QuantumTlsTransformer />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/packages-for-developers" element={<PackagesForDevelopers />} />
          {/* Catch-all route to redirect incorrect URLs to homepage */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        {/* Add Cookie Consent Banner */}
        <CookieConsentBanner />
      </div>
    </Router>
  );
}

export default App;
